import { DescriptionHeader } from "./description-header";

export type DescriptionForSmallAccommodationMessages = {
  heading: string;
  noAdditionalFee: string;
};

const JA_MESSAGES: DescriptionForSmallAccommodationMessages = {
  heading: "こちらの施設は Small サイズです",
  noAdditionalFee: "1泊あたりの追加料金はかかりません。",
};

/**
 * スモールサイズの宿泊施設の説明
 */
export function DescriptionForSmallAccommodation({
  messages = JA_MESSAGES,
}: {
  messages?: DescriptionForSmallAccommodationMessages;
} = {}) {
  return (
    <div className="mt-[20px] w-full space-y-[20px]">
      <DescriptionHeader iconSrc="/i/icon_small.svg" iconAlt="SMALL">
        {messages.heading}
      </DescriptionHeader>
      <div className="text-xs md:text-sm">{messages.noAdditionalFee}</div>
    </div>
  );
}
